"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mnemonic = void 0;
const hdnode_1 = require("ethers/utils/hdnode");
const crypto_1 = require("crypto");
var mnemonic;
(function (mnemonic) {
    // see https://github.com/satoshilabs/slips/blob/master/slip-0044.md
    const VET_DERIVATION_PATH = `m/44'/818'/0'/0`;
    /** generate BIP39 mnemonic words */
    function generate() {
        return (0, hdnode_1.entropyToMnemonic)((0, crypto_1.randomBytes)(128 / 8)).split(' ');
    }
    mnemonic.generate = generate;
    /**
     * check if the given mnemonic words have valid checksum
     * @param words mnemonic words
     */
    function validate(words) {
        return (0, hdnode_1.isValidMnemonic)(words.join(' '));
    }
    mnemonic.validate = validate;
    /**
     * derive private key from mnemonic words according to BIP32.
     * the derivation path is defined at https://github.com/satoshilabs/slips/blob/master/slip-0044.md
     */
    function derivePrivateKey(words) {
        const node = (0, hdnode_1.fromMnemonic)(words.join(' '));
        return Buffer.from(node.derivePath(`${VET_DERIVATION_PATH}/0`).privateKey.slice(2), 'hex');
    }
    mnemonic.derivePrivateKey = derivePrivateKey;
})(mnemonic = exports.mnemonic || (exports.mnemonic = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibW5lbW9uaWMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY3J5L21uZW1vbmljLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLGdEQUF1RjtBQUN2RixtQ0FBcUM7QUFFckMsSUFBaUIsUUFBUSxDQXlCeEI7QUF6QkQsV0FBaUIsUUFBUTtJQUN2QixvRUFBb0U7SUFDcEUsTUFBTSxtQkFBbUIsR0FBRyxpQkFBaUIsQ0FBQztJQUU5QyxvQ0FBb0M7SUFDcEMsU0FBZ0IsUUFBUTtRQUN0QixPQUFPLElBQUEsMEJBQWlCLEVBQUMsSUFBQSxvQkFBVyxFQUFDLEdBQUcsR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQyxHQUFHLENBQUMsQ0FBQztJQUM1RCxDQUFDO0lBRmUsaUJBQVEsV0FFdkIsQ0FBQTtJQUVEOzs7T0FHRztJQUNILFNBQWdCLFFBQVEsQ0FBQyxLQUFlO1FBQ3RDLE9BQU8sSUFBQSx3QkFBZSxFQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztJQUMxQyxDQUFDO0lBRmUsaUJBQVEsV0FFdkIsQ0FBQTtJQUVEOzs7T0FHRztJQUNILFNBQWdCLGdCQUFnQixDQUFDLEtBQWU7UUFDOUMsTUFBTSxJQUFJLEdBQUcsSUFBQSxxQkFBWSxFQUFDLEtBQUssQ0FBQyxJQUFJLENBQUMsR0FBRyxDQUFDLENBQUMsQ0FBQztRQUMzQyxPQUFPLE1BQU0sQ0FBQyxJQUFJLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQyxHQUFHLG1CQUFtQixJQUFJLENBQUMsQ0FBQyxVQUFVLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssQ0FBQyxDQUFDO0lBQzdGLENBQUM7SUFIZSx5QkFBZ0IsbUJBRy9CLENBQUE7QUFDSCxDQUFDLEVBekJnQixRQUFRLEdBQVIsZ0JBQVEsS0FBUixnQkFBUSxRQXlCeEIifQ==